import { useQuery } from '@tanstack/react-query';
import { getBrand } from '../../api/brand.ts';

export default function useBrand(brandId: string | null | undefined) {
  return useQuery({
    queryKey: ['brands', brandId],
    queryFn: async () => {
      return await getBrand(brandId!);
    },
    enabled: !!brandId,
  });
}
